import PassengerTnesService from 'js/services/api/passenger/tnes.js'

import template from './index.pug'
import DeregisterConfirm from './_confirm'
import WarningConfirm from './_warning'
import DeregisterSuccessful from './_successful'

// @vue/component
export default {
  template: template(),
  props: {
    tne: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      childComponent: DeregisterConfirm
    }
  },
  computed: {
  },
  methods: {
    setChildComponent(component) {
      this.childComponent = component
    },
    async onDeregister() {
      let childComponent = null

      await PassengerTnesService.deregister(this.tne.id).then(() => {
        this.$emit('deregister-successful')
        childComponent = DeregisterSuccessful
      }).catch(() => {
        childComponent = WarningConfirm
      })

      this.setChildComponent(childComponent)
    }
  }
}
